<script lang="ts">
    import type {Photo} from "./Types";
    import {authBlobUrl} from "../../Auth";
    import Minithumbnail from "./Minithumbnail.svelte";

    export let entity: Photo
    export let telegramMessageId: string
    export let isChannel: string

    let src = null
    let fullScreen: boolean = false
    let photoIndex: number = false

    async function loadFullImage() {
        if (src !== null) {
            return true
        }
        let index = 0
        if (isChannel != 1) {
            index = entity.sizes.length - 1
        }
        let photoId = entity.sizes[index]?.photo?.id ?? null
        let remotePhotoId = entity.sizes[index]?.photo?.remote?.id ?? ''

        if (photoId === null) {
            console.warn('without photo id')
            return false;
        }
        try {
            src = await authBlobUrl(`/message/${telegramMessageId}/attachment/${photoId}/${remotePhotoId}`)
        } catch (error) {
            alert("Повнорозмірне зображення відсутнє")
        }
        photoIndex = index
    }
</script>

<Minithumbnail entity="{entity.minithumbnail}"/><br/>
{#if (src==null)}
    <div on:click={loadFullImage}
         class="img-thumbnail position-relative"
         style:height={entity.sizes[0].height + 'px'}
         style:width={entity.sizes[0].width + 'px'}
         style:background="no-repeat center center"
         style:background-size="contain"
         style:background-image={entity.minithumbnail?.data ? `url(data:image/png;base64,${entity.minithumbnail?.data})` : null}>
        <div class="rounded-circle text-center align-middle position-absolute top-0 bottom-0 end-0 start-0 m-auto"
             style="height: 50px; width: 50px; cursor: pointer; background: rgba(255, 255, 255, 0.7)">
            <i class="bi bi-arrow-bar-down h1"></i>
        </div>
    </div>
{:else if (!fullScreen)}
    <div on:click={()=>fullScreen=!fullScreen}
         class="img-thumbnail"
         style:height={entity.sizes[0].height + 'px'}
         style:width={entity.sizes[0].width + 'px'}
         style:background="no-repeat center center"
         style:background-size="contain"
         style:background-image={`url(${src})`}
    ></div>
{:else}
    <div on:click={()=>fullScreen=!fullScreen} on:keypress={()=>fullScreen=!fullScreen}
         class="position-fixed top-0 end-0 bottom-0 start-0 overflow-auto"
         style="background: rgba(0, 0, 0, 0.75); z-index: 1040;">
        <button class="btn btn-secondary rounded-circle position-absolute"
                style="top: 75px; right: 20px;">
            <i class="bi bi-x"></i>
        </button>
        <div class="img-thumbnail position-absolute top-0 end-0 bottom-0 start-0 m-auto"
             style:height={entity.sizes[photoIndex].height + 'px'}
             style:width={entity.sizes[photoIndex].width + 'px'}
             style:background="no-repeat center center"
             style:background-size="contain"
             style:background-image={`url(${src})`}
        ></div>
    </div>
{/if}
